const styles = theme => ({
  Title: {
    fontWeight: '500',
    marginBottom: '5px',
    fontSize: '21px',
    color: '#130F26',
  },
  subTitle: {
    fontSize: '16px',
    color: '#484456',
    lineHeight: '24px',
    marginTop: '10px',
    marginBottom: '8px',
  },
  btns: {
    margin: '.5rem 0',
    padding: '14px 22px',
    fontSize: '1rem',
    textTransform: 'none',
  },
  infoBtn: {
    background: '#CED1D6',
    color: '#8C9099',
    '&:hover': {
      background: '#ced1d6cc',
    },
  },
  textPrimary: {
    color: '#0088FF',
    cursor: 'pointer',
  },
  textGreen: {
    color: theme.palette.primary.adgmGreen,
  },
  textDisabled: {
    color: '#565960',
  },
  weightMedium: {
    fontWeight: '500',
  },
  tryAgainContainer: {
    margin: '6px 0px',
  },
  tryAgainText: {
    marginLeft: '4px',
    color: '#0088FF',
    fontWeight: '400',
  },
  textSizeRaguler: {
    fontSize: '16px',
  },
  formArea: {
    paddingTop: '20px',
  },
  formControl: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  inputControl: {
    border: '1px solid #CED1D6',
    borderRadius: '10px',
    height: '60px',
    padding: '7px 16px',
    width: '100%',
  },
  warrningMessage: {
    display: 'flex',
    padding: '12px',
    background: '#EBF7FF',
    border: '1px solid #0496FF',
    borderRadius: '4px',
    fontSize: '14px',
    alignItems: 'flex-start',
    margin: '1rem 0',
  },
  infoSvg: {
    flexShrink: '0',
    marginRight: '8px',
    marginTop: '2px',
  },
  otpInputHolder: {
    display: 'grid',
    gridTemplateColumns: '64px 64px 64px 64px',
    justifyContent: 'center',
    gap: '16px',
    overflow: 'hidden',
    margin: '0',
  },
  otpinputControl: {
    border: '1px solid #342D3D',
    borderRadius: '10px',
    height: '67px',
    width: '64px',
    padding: '5px',
    margin: '0 16px',
    fontSize: '40px',
    textAlign: 'center',
  },
  otpinputlabel: {
    color: '#0088FF',
    fontSize: '14px',
    fontWeight: '600',
    marginBottom: '10px',
  },
  redBtn: {
    background: '#0088FF',
    color: theme.palette.primary.contrastText,

    '&:hover': {
      background: '#0088FF',
      opacity: '0.7',
    },
    '& svg': {
      marginRight: theme.spacing(1),
    },
  },
  inputField: {
    padding: '7px 22px',
    fontSize: '27px',
    borderRadius: '0px',
    border: '1px solid #ced1d6',
    height: '64px',
  },
  warrningtextHolder: {
    '& strong': {
      fontSize: '12px',
      fontWeight: '500',
    },
    '& p': {
      fontSize: '12px',
      fontWeight: '400',
    },
  },
  '@media (max-width: 600px)': {
    fixedonmobile: {
      position: 'fixed',
      bottom: '0',
      left: '0',
      right: '0',
      zIndex: '1021',
      background: '#fff',
      textAlign: 'center',
      padding: '15px 15px 20px',
    },
    textSizeRaguler: {
      fontSize: '12px',
    },
    warrningMessage: {
      fontSize: '12px',
    },
  },
});

export default styles;
